import React, { useState } from "react";
import { useField } from "formik";
import { useFieldError, useUpdateEffect } from "@/hooks";
import { TextArea } from "@/components/ui/TextArea";
import { ValidationMessage } from "../ValidationMessage";

export function FormTextArea({ name, label, isRequired, rows = 4, ...props }) {
  const [, meta, helpers] = useField(name);
  const hasError = useFieldError(name);

  const [currentValue, setCurrentValue] = useState(
    meta.value || meta.initialValue
  );

  useUpdateEffect(() => {
    setCurrentValue(meta.value);
  }, [meta.value]);

  const handleChange = (e) => {
    setCurrentValue(e.target.value);
    helpers.setValue(e.target.value);
    helpers.setError("");
  };

  const handleBlur = () => {
    helpers.setTouched(true);
  };

  return (
    <div className="flex flex-col">
      <TextArea
        label={label}
        name={name}
        value={currentValue}
        hasError={hasError}
        onChange={handleChange}
        onBlur={handleBlur}
        isRequired={isRequired}
        rows={rows}
        {...props}
      />

      <ValidationMessage name={name} />
    </div>
  );
}
